import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation NarrativeEnabledNotify($uid: String!, $episodes: Boolean, $episode_type: String){
        narrative_enabled_notify (uid: $uid, episodes: $episodes, episode_type: $episode_type) {
            success
        }
    }
`;

export async function narrativeEnabledNotify(uid: string, episodes: boolean, episode_type: string | undefined): Promise<{ success: boolean }> {
    const result: FetchResult<{ narrative_enabled_notify: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid, episodes, episode_type },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.narrative_enabled_notify;
}
